export default "__VITE_ASSET__DgE5ahSu__"